import { colors } from "@mui/material";

const colorConfigs = {
  sidebar: {
    bg: "#183c64",
    color: "#eeeeee",
    hoverBg: "#2A69B0",
    activeBg: "#2E5683"
  },
  topbar: {
    bg: "#fff",
    color: "#183c64"
  },
  mainBg: colors.grey["100"]
};

export default colorConfigs;